import React from 'react';

class Error404 extends React.Component {
    render() {
        return (
            <div className="not-found">
                <div className="not-found__code">404
                </div>
                <div className="not-found__error">ошибка
                </div>
                <div className="not-found__robot">
                </div>
                <div className="not-found__desc">страница не найдена
                </div>
            </div>
        )
    }
}

export default Error404;



// WEBPACK FOOTER //
// ./src/Components/404.js